<template>
  <div class="main">
    <landingBanner
      landingUrl="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/westfoodall/banner.jpg"
    ></landingBanner>
    <div class="content" style="margin-top:-5px;">
      <footerForm color="#fff" bag="#a96832" words="获取学费"></footerForm>
      <indexTitle title1="适合谁学" title2="总有一个适合你" color="#a96832"></indexTitle>
      <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
        <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/westfoodall/new1.jpg">
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
      </a>
    </div>

    <div class="part1">
      <indexTitle title1="热门课程" title2="课程荟萃中外西点教育理念精髓" color="#fff"></indexTitle>
      <div class="list">
        <div class="list-one">
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/westfoodall/part1-1.jpg"
          />
          <find3 goto="/baking15"></find3>
        </div>
        <div class="list-one">
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/westfoodall/part1-2.jpg"
          />
          <find3 goto="/baking9"></find3>
        </div>
        <div class="list-one">
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/westfoodall/part1-3.jpg"
          />
          <find3 goto="/baking6"></find3>
        </div>
        <div class="list-one">
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/westfoodall/part1-4.jpg"
          />
          <find3 goto="/baking3"></find3>
        </div>
        <div class="list-one">
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/westfoodall/part1-5.png"
          />
          <find3 goto="/baking1"></find3>
        </div>
        <div class="list-one">
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/westfoodall/part1-6.jpg"
          />
          <find3 goto="chat"></find3>
        </div>
      </div>
    </div>
    <div class="content">
      <indexTitle title1="学员作品" title2="看一眼就会爱上TA" color="rgb(122, 51, 23)"></indexTitle>
     <van-swipe :autoplay="3000" indicator-color="white">
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/westfoodall/part2-1.png"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/westfoodall/part2-2.png"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
          <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/westfoodall/part2-3.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
      </van-swipe>
      <find></find>
      <indexTitle title1="教学环境" title2="简约欧式教学环境" color="rgb(122, 51, 23)"></indexTitle>
       <van-swipe :autoplay="3000" indicator-color="white">
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/westfoodall/part4-1.png"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/westfoodall/part4-2.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
      </van-swipe>
      <find></find>
    </div>
    <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/westfoodall/part3.jpg">
      <template v-slot:loading>
        <van-loading size="20" color="#fff" />
      </template>
    </van-image>
    <div class="content">
      <indexTitle title1="技能+证书双保险" title2="学技能照样拿大学文凭" color="rgb(122, 51, 23)"></indexTitle>
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/westfoodall/part5.jpg">
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <div class="button">
        <van-button color="#ff4900" style="width:100%" to="chat">咨询证书详情</van-button>
      </div>
      <indexTitle title1="成功创就业学员" title2="就业推荐进名企 创业全程帮扶" color="rgb(122, 51, 23)"></indexTitle>
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/westfoodall/part6.jpg">
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
    </div>
    <footerForm color="#fff" bag="#ff4900" words="点击获取学费报价"></footerForm>
    <div class="h25px" style="width:100%;height:25px;"></div>
    <foot></foot>
  </div>
</template>

<script>
export default {
  components: {
    landingBanner: () => import("@/components/common/landing-banner"),
    back: () => import("@/components/head/back"),
    foot: () => import("@/components/foot/foot"),
    find: () => import("@/components/common/find"),
    find3: () => import("@/components/common/find3"),
    indexTitle: () => import("@/components/common/indexTitle"),
    footerForm: () => import("@/components/form/footerForm")
  }
};
</script>

<style lang="less" scoped>
/deep/ .van-swipe__indicators{
  bottom: 15px;
    left: 10%;
}
.part1 {
  width: 100%;
  padding: 10px 0 10px 0;
  background-image: url(https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/all/back.jpg);
  background-size: 100% 792px;
}
.content {
  width: 100%;
  padding: 10px;
  background: #fff;
}
.list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 10px;
}
.list-one {
  width: 48.5%;
}
.button {
  width: 100%;
  text-align: center;
  margin-top: 10px;
}
</style>